import api from "./api";

/**
 * Görev (To-Do) uçları (backend: /api/tasks). Yanıtlar ApiResponse zarfında
 * (res.data.data). Salon ekibinin ortak görev listesi; MANAGER ve STAFF erişir.
 */
export const taskService = {
  list: () => api.get("/tasks"),
  limit: () => api.get("/tasks/limit"),
  create: (payload) => api.post("/tasks", payload),
  update: (id, payload) => api.put(`/tasks/${id}`, payload),
  setStatus: (id, status) => api.patch(`/tasks/${id}/status`, null, { params: { status } }),
  remove: (id) => api.delete(`/tasks/${id}`),
};
